import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useInboxStore } from '@dashboardApp/stores/InboxStore';
import useNotifications from '@dashboardApp/composables/useNotifications';
import { viewThread } from '@dashboardApp/helpers/inbox';
export default {
  __name: 'ArchiveMessageButton',
  props: {
    id: {
      type: [String, Number]
    },
    isArchived: {
      type: Boolean
    },
    archiveClass: {
      type: String,
      required: false,
      "default": ''
    },
    unarchiveClass: {
      type: String,
      required: false,
      "default": ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var router = useRouter();
    var inboxStore = useInboxStore();
    var _useNotifications = useNotifications(),
      addNotification = _useNotifications.addNotification;
    var isArchivedTemp = ref(props.isArchived);
    function archive() {
      inboxStore.archiveMessage(props.id).then(function (nextThread) {
        addNotification({
          message: 'Thread has been archived.',
          timeout: 5000,
          type: 'success'
        });
        isArchivedTemp.value = true;
        if (nextThread !== false) {
          viewThread(router, nextThread);
        }
      });
    }
    function unarchive() {
      inboxStore.archiveMessage(props.id, false).then(function (nextThread) {
        addNotification({
          message: 'Thread has been unarchived.',
          timeout: 5000,
          type: 'success'
        });
        isArchivedTemp.value = false;
        if (nextThread !== false) {
          viewThread(router, nextThread);
        }
      });
    }
    return function (_ctx, _cache) {
      return !isArchivedTemp.value ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
          return archive();
        }, ["prevent"])),
        "class": _normalizeClass([__props.archiveClass, "text-decoration-none d-inline-block ms-1 hover-opacity"]),
        href: ""
      }, [_renderSlot(_ctx.$slots, "archiveImg", {}, function () {
        return [_cache[2] || (_cache[2] = _createElementVNode("img", {
          src: "/img/v5/db-ic_archive.svg"
        }, null, -1))];
      })], 2)) : (_openBlock(), _createElementBlock("a", {
        key: 1,
        onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
          return unarchive();
        }, ["prevent"])),
        href: "",
        "class": _normalizeClass([__props.unarchiveClass, "text-decoration-none d-inline-block me-2 hover-opacity"])
      }, [_renderSlot(_ctx.$slots, "unarchiveImg", {}, function () {
        return [_cache[3] || (_cache[3] = _createElementVNode("img", {
          src: "/img/v5/db-ic_unarchive-sm.svg"
        }, null, -1))];
      })], 2));
    };
  }
};